import { render, staticRenderFns } from "./TabGeneralDetails.vue?vue&type=template&id=cbade850&"
import script from "./TabGeneralDetails.vue?vue&type=script&lang=js&"
export * from "./TabGeneralDetails.vue?vue&type=script&lang=js&"
import style0 from "./TabGeneralDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports